/** Display value for controlled number inputs — empty when cleared or unset. */
export function numberInputDisplay(value) {
  if (value === null || value === undefined || value === "") return "";
  return String(value);
}

/** Parse form string to number for API; null when empty or invalid. */
export function parseNumberInput(value, { integer = false } = {}) {
  if (value === null || value === undefined || value === "") return null;
  const n = integer ? parseInt(String(value), 10) : parseFloat(String(value));
  return Number.isFinite(n) ? n : null;
}

/** Parse for live calculations where empty should count as zero. */
export function parseNumberInputOrZero(value, opts) {
  return parseNumberInput(value, opts) ?? 0;
}

/** Coerce selected object keys from string form values to numbers (or null). */
export function mapNumberFields(obj, keys, opts) {
  const out = { ...obj };
  for (const key of keys) {
    if (key in out) out[key] = parseNumberInput(out[key], opts);
  }
  return out;
}

export const PRODUCTION_YIELD_NUMBER_KEYS = [
  "input_qtl",
  "head_rice_qtl",
  "nakku_qtl",
  "bran_qtl",
  "husk_qtl",
  "dust_qtl",
  "bags_packed",
];

export const PADDY_LAB_NUMBER_KEYS = [
  "moisture_pct",
  "yield_pct",
  "broken_pct",
  "damage_pct",
  "green_pct",
  "immature_pct",
  "admixture_pct",
  "pr_pct",
  "length_mm",
  "choba_pct",
];
